import {Injectable} from '@angular/core';
import * as Papa from 'papaparse';
import * as pdfMake from 'pdfmake/build/pdfmake';
// import * as pdfFonts from "pdfmake/build/vfs_fonts";
import {AppSettings} from "../../config/app-setting";
import {DecodedToken} from "../entities/decodedToken";
import {jwtDecode} from "jwt-decode";
import {HttpHeaders} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor() { (window as any).pdfMake.vfs = pdfMake.vfs; }

  public GetSecurityToken() : string
  {
    let token = localStorage.getItem(AppSettings.myTokenKey);
    if (token !== null && token !== undefined && token !== '')
    {
      return token;
    }
    return "";
  }

  public GetCustomerId() : string
  {
    let token = this.GetSecurityToken();
    if (token !== null && token !== undefined && token !== '')
    {
      const decodedToken: DecodedToken = jwtDecode(token);
      return decodedToken.CustomerId;
    }
    return "";
  }

  public GetPasswordIsTemporary() : boolean
  {
    let token = this.GetSecurityToken();
    if (token !== null && token !== undefined && token !== '')
    {
      const decodedToken: DecodedToken = jwtDecode(token);
      return decodedToken.PasswordIsTemporary;
    }
    return false;
  }

  public GetUserIsEnabled() : boolean
  {
    let token = this.GetSecurityToken();
    if (token !== null && token !== undefined && token !== '')
    {
      const decodedToken: DecodedToken = jwtDecode(token);
      return decodedToken.UserIsEnabled;
    }
    return false;
  }

  GetHttpHeader()
  {
    return {
      headers: new HttpHeaders({'Authorization': 'Bearer ' + this.GetSecurityToken()})
    };
  }

  GetFetchHttpHeader() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.GetSecurityToken()
    });

    // Converti HttpHeaders in un oggetto plain
    const headersObject: { [key: string]: string } = {};
    headers.keys().forEach(key => {
      headersObject[key] = headers.get(key) || '';
    });

    return {
      headers: headersObject
    };
  }

  getCurrentDateTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');
    return `${year}${month}${day}_${hours}${minutes}${seconds}`;
  }

  exportCsv(myJsonObject: any, fileName: string) {
    const csv = Papa.unparse(myJsonObject , { delimiter: ';' });
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', fileName+this.getCurrentDateTime()+'.csv');
    link.click();
  }

  exportPdf(pageTitle: string, pdfName: string,
            headerFontSize: number,
            tableFontSize: number,
            testoTipologiaReport: string,
            iconaAzienda: string, estrattoIl: string,
            disclaimer:string, disclaimerSize: number,
            colonne: any, righe: any)
  {
    const larghezzeAuto = Array(colonne.length).fill('auto');
    pdfMake.createPdf({
      pageSize: 'A4',
      pageOrientation: 'landscape',
      pageMargins: [15, 60, 15, 40],

      // // In attesa di implementazione - NON RIMUOVERE----------------------
      // background: [
      //   {
      //     image: this.backgroundBase64Data,
      //     width: 632, // Larghezza dell'immagine della filigrana
      //     height: 446, // Altezza dell'immagine della filigrana
      //     opacity: 0.25
      //     ,absolutePosition: { x: 150, y: 100 } // Posizione assoluta dell'immagine di sfondo
      //   }
      // ],
      //------------------------------------------------------------------
      header: {
        stack: [
          {
            columns: [
              {
                text: testoTipologiaReport,
                alignment: 'left',
                margin: [15, 24, 0, 0]
              },
              {
                width: 550,
                text: pageTitle,
                style: 'header'
                , margin: [0, 20, 15, 90]
              },
              { image: iconaAzienda, width: 140, alignment: 'right', margin: [0, 10, 5, 0] }
            ]
          }
        ]
      },
      content: [
        {
          style: 'table',
          table: {
            headerRows: 1,
            widths: larghezzeAuto,
            body: [colonne, ...righe]
          }
        }
      ],
      footer: function(currentPage, pageCount) {
        return {
          stack: [
            {
              columns: [
                {
                  text: disclaimer,
                  fontSize: disclaimerSize,
                  alignment: 'center'
                  ,margin: [15, 0, 0, 0]
                }
              ]
            },
            {
              columns: [
                {
                  text: estrattoIl + new Date().toLocaleDateString(),
                  alignment: 'left'
                  ,margin: [15, 0, 0, 0]
                },
                {
                  text: 'Pagina ' + currentPage.toString() + ' di ' + pageCount,
                  alignment: 'right'
                  ,margin: [0, 0, 15, 0]
                }
              ]
            }
          ],
          alignment: 'center'
        }
      },
      styles: {
        header: {
          fontSize: headerFontSize,
          bold: true,
          alignment: 'center'
        },
        table: {
          fontSize: tableFontSize
        },
        boldTableHeader: {
          bold: true,
          fillColor: '#DDDDDD'
        },
        redText: {
          color: 'red'
        },
        blackText: {
          color: 'black'
        }
      }
     }).download(pdfName);

  }

  addThousandsSeparator(value: string): string {
    // Controlla se il valore di input è vuoto
    if (!value) return '';

    // Rimuovi tutti i punti presenti nella stringa
    value = value.replace(/\./g, '');

    if(value.includes('Infinity'))
    {
      return '';
    }

    if(value.includes('NaN'))
    {
      value = '0,00';
    }

    // Dividi la stringa in due parti: parte intera e parte decimale
    const parts = value.split(',');

    // Aggiungi un separatore di migliaia alla parte intera
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    // Unisci le due parti e restituisci il valore finale
    return parts.join(',');
  }

  addThousandsSeparatorAndPercentage(value: string): string {
    // Controlla se il valore di input è vuoto
    if (!value) return '';

    // Rimuovi tutti i punti presenti nella stringa
    value = value.replace(/\./g, '');

    if(value.includes('Infinity'))
    {
      return '';
    }

    if(value.includes('NaN'))
    {
      value = '0,00';
    }

    // Dividi la stringa in due parti: parte intera e parte decimale
    const parts = value.split(',');

    // Aggiungi un separatore di migliaia alla parte intera
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    // Unisci le due parti e restituisci il valore finale
    return parts.join(',')+'%';
  }
}

